import { SubjectListItem } from '@/project-subject/subject-config/subject-config'

export const MingTing: SubjectListItem = {
  id: 'ming_ting',
  debug_subject_name: '企业版',
  domains: [],
  logo_login_page: require('./_images/logo-login-page.png'),
  logo_dashboard_header: require('./_images/logo-dashboard-header.png'),
  logo_dashboard_header_dark: require('./_images/logo-dashboard-header-dark.png'),
  phone_pre_sale: '186-8811-5347',
  phone_after_sale: '186-7086-0265',
  mail: 'contactus@mingting.cn',
  sign_app_id: 'frontend',
  sign_key: 'Oyy1KTQ0op56.'
}
